import React, { useState } from 'react';
import useFetch from '../../hooks/useFetch';
import { useNavigate } from 'react-router-dom';
import { Accordion, Row } from 'react-bootstrap';
import GriqnaTable from './GriqnaTable';

const Griqna = () => {
    const navigate = useNavigate()
    const [selectedId, setSelectedId] = useState([]);

    const { data, isLoading } = useFetch('gri/modules');

    if (isLoading) {
        return (
            <>
                <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                    <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                        <h1 className="h2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                    </div>
                </main>
            </>
        )
    }


    const handleNext = () => {
        const route = `/griqnadetails`;
        navigate(route, { state: { selectedId } });
    }

    const handleClick = (name, id) => {

        setSelectedId((Ids) => {
            const isSelected = Ids.some((item) => item.id === id && item.name === name);

            if (isSelected) {
                // Remove the ID and Name if they are already present
                return Ids.filter((selectedItem) => !(selectedItem.id === id && selectedItem.name === name));
            } else {
                // Add the ID and Name if they are not present
                return [...Ids, { id, name }];
            }
        });
    };

    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom" >
                <div className="fixed-div">
                    <div className="h2">GRI Q & A</div>
                    
                </div>
            </div>
            <div className='row'>
                <Row xs={1} md={4} className="g-4 mb-5">
                    {data.length === 0
                        ? ""
                        : data.map((val, idx) => (
                            <div key={idx}>
                                <div
                                    className={selectedId.some((item) => item.id === val.id && item.name === val.module_name) ? "gricardactive" : "gricardnotactive"}
                                    id={val.id}
                                    onClick={() => handleClick(val.module_name, val.id)}
                                >
                                    {val.module_name}
                                </div>
                            </div>
                        ))}
                </Row>
                <div>
                    <button className='btn btn-primary btn-add' onClick={handleNext} disabled={selectedId.length == 0}> Next</button>
                </div>
            </div>
            <br></br>
            <hr></hr>
            <Accordion>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>GRI Q & A Reports</Accordion.Header>
                    <Accordion.Body>
                        <div>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Year</th>
                                        <th>Created Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <GriqnaTable />

                                </tbody>
                            </table>
                        </div>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>

        </main>
    );
};

export default Griqna;
